import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { DateTime } from 'luxon';

import { BaseApiService } from './base-api.service';
import { environment } from '../../../environments/environment';
import { Client } from '../models/client';
import { ClientMatterContactDetails } from '../models/client-matter-contact-details';

@Injectable({
  providedIn: 'root',
})
export class ClientService extends BaseApiService<Client> {

  private clientMatterContactDetailsCache : Map<string, BehaviorSubject<ClientMatterContactDetails>> = new Map();

  private mfaSupressed = new BehaviorSubject(false);
  mfaSupressedTimeCutoff = DateTime.utc().minus({day: 3});

  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/clients`);
    this.internalGetMfaReminderSupressed();
  }

  public getClientMatterContactDetails(matterId?: string): Observable<ClientMatterContactDetails>{

    // Default is an arbitrary key to store the default value for no matterId
    const key = matterId || 'default';

    // Try to retrieve the value from the cache
    if(this.clientMatterContactDetailsCache.has(key)){
      var cachedValue = this.clientMatterContactDetailsCache.get(key);
      if(cachedValue?.value){
        return cachedValue;
      }
    }


    // Setup our params to optionally include the matterId
    let httpParams = new HttpParams();
    if (matterId !== undefined) {
      httpParams = httpParams.append('matterId', matterId);
    }

    // Call our api, caching the result, and returning the observable
    return this.httpClient.get<ClientMatterContactDetails>(this.baseApiUrl + '/MatterContactDetails', {
      params: httpParams,
    }).pipe(tap( val =>{
      const newCacheVal = new BehaviorSubject<ClientMatterContactDetails>(val);
      this.clientMatterContactDetailsCache.set(key, newCacheVal);
      return newCacheVal.next(val);
    }));
  }

  supressMfaReminder() {
    localStorage.setItem('MfaReminderSupressedTime', DateTime.utc().toISO());
    this.mfaSupressed.next(true);
  }

  unsupressMfaReminder() {
    localStorage.removeItem('MfaReminderSupressedTime');
    this.mfaSupressed.next(false);
  }


  private internalGetMfaReminderSupressed() {
    const mfaSupressedTimeString = localStorage.getItem('MfaReminderSupressedTime');
    let mfaReminderIsSupressed = false;

    let mfaSupressedTime: DateTime | null = null;
    if (mfaSupressedTimeString !== null) {
      mfaSupressedTime = DateTime.fromISO(mfaSupressedTimeString);
    }

    mfaReminderIsSupressed = (mfaSupressedTime !== null && this.mfaSupressedTimeCutoff.diff(mfaSupressedTime).toMillis() < 0)
    this.mfaSupressed.next(mfaReminderIsSupressed);

    return of(mfaReminderIsSupressed);
  }

  public getMfaReminderSupressed() {
    return this.mfaSupressed.asObservable();
  }
}
